import React, { useState } from "react";
import { Lock, ShieldAlert } from "lucide-react";
import { Button } from "../ui/button";
import { Textarea } from "../ui/textarea";

export function LockedSectionView({ section, onOverrideEdit }) {
  const [overrideEnabled, setOverrideEnabled] = useState(false);

  if (section.allow_override && overrideEnabled) {
    return (
      <div className="space-y-2">
        <div className="flex items-center gap-2 p-2 bg-blue-50 dark:bg-blue-950/30 rounded-sm text-xs text-blue-600">
          <ShieldAlert size={14} />
          <span>Override mode active - editing a normally locked section</span>
          <Button variant="ghost" size="sm" className="ml-auto h-6 text-xs" onClick={() => setOverrideEnabled(false)}>
            Re-lock
          </Button>
        </div>
        <Textarea
          value={section.content}
          onChange={(e) => onOverrideEdit(e.target.value)}
          rows={8}
          className="rounded-sm border-blue-300"
          data-testid={`section-${section.id}-override-textarea`}
        />
      </div>
    );
  }

  return (
    <div className="bg-slate-50 dark:bg-slate-800 p-4 rounded-sm">
      <p className="text-sm text-slate-600 dark:text-slate-400 whitespace-pre-wrap">
        {section.content || "No content defined in template"}
      </p>
      {section.allow_override ? (
        <div className="flex items-center justify-between mt-3">
          <p className="text-xs text-amber-600 flex items-center gap-1">
            <Lock size={12} />
            This section is locked by default
          </p>
          <Button
            variant="outline"
            size="sm"
            className="h-7 text-xs gap-1 text-blue-600 border-blue-300 hover:bg-blue-50"
            onClick={() => setOverrideEnabled(true)}
            data-testid={`section-${section.id}-override-btn`}
          >
            <ShieldAlert size={12} />
            Enable Override
          </Button>
        </div>
      ) : (
        <p className="text-xs text-amber-600 mt-3 flex items-center gap-1">
          <Lock size={12} />
          This section is locked and cannot be edited
        </p>
      )}
    </div>
  );
}
